<template>
  <div class="custmize-test" ref="infoBox">
    <div class="card-sub">
      <div ref="refQuestionType" class="card-block-pattern">
       <v-card v-for="(que, i) in questionsList" :key="i">
          <v-row>
            <div class="row-block-20">
              <v-col cols="12" sm="5">
                <div
                  class="myt-dropdown add-ch-arrow practice-session-drop-outer"
                >
                  <div class="practice-session-drop-down">
                    <div class="field-data">
                      <div class="ts-label">Question Type:</div>
                      <div class="ts-field">
                        <v-select
                          v-model="que.questionType"
                          :items="getQuestionTypes(que)"
                          @change="checkQuestionType(que, i)"
                          class=""
                          dense
                          outlined
                          hide-details
                        ></v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="3">
                <div class="field-data">
                  <div class="ts-label">Questions/Subject:</div>
                  <div class="ts-field">
                    <v-text-field
                      v-model="que.numberOfQuestion"
                      min="1"
                      type="number"
                      @keydown.space.prevent
                      @keypress="allowedOnlyNumber($event, true)"
                      @input="que.noOfMandatoryQuestions = que.numberOfQuestion"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="3" class="MandatoryQuestions">
                <div
                  class="field-data"
                  v-if="
                    que.questionType.id != QUE_TYPES.COMPREHENSION &&
                      que.questionType.id != QUE_TYPES.TC
                  "
                >
                  <div class="ts-label">Mandatory Questions:</div>
                  <div class="ts-field">
                    <v-text-field
                      v-model="que.noOfMandatoryQuestions"
                      type="number"
                      @keydown.space.prevent
                      @keypress="allowedOnlyNumber($event, true)"
                      min="1"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </div>
                </div>

                <div
                  v-if="
                    Number(que.numberOfQuestion) >
                      Number(que.noOfMandatoryQuestions)
                  "
                  class="test-name-block radio-MandatoryQuestions"
                >
                  <div class="private-radio create-question-radio-group">
                    <div
                      class="create-question-radio myt-test-creation"
                      v-for="(sType, index) in mandatoryType"
                      :key="index"
                    >
                      <input
                        type="radio"
                        name="allMandatory"
                        id="allMandatory"
                        v-model="que.allow_all"
                        :value="sType.value"
                        color="red"
                      />
                      <i
                        v-if="que.allow_all == sType.value"
                        aria-hidden="true"
                        class="v-icon notranslate mdi mdi-radiobox-marked theme--light red--text"
                      ></i>
                      <i
                        v-else
                        aria-hidden="true"
                        class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
                      ></i>
                      <label :for="sType.value">{{
                        sType.label.replace(
                          "#mandatoryQuestions",
                          que.noOfMandatoryQuestions
                        )
                      }}</label>
                    </div>
                  </div>
                </div>
              </v-col>
            </div>
            <div class="row-block-20">
              <v-col cols="12" sm="5">
              </v-col>
              <v-col cols="12" sm="3">
              </v-col>
              <v-col cols="12" sm="3">
                <div
                  v-if="showPartialMarking(que)"
                  class="check-cust mr-btm-myt-20"
                >
                  <v-checkbox
                    v-model="que.partialMarking"
                    label="Partial Marking"
                    dense
                    hide-details
                  ></v-checkbox>
                </div>
              </v-col>
              <v-col cols="12" sm="1" class="delete-icon-pos">
                <div class="deleteicon delete-icons mr-btm-myt-20">
                  <v-btn
                    class="cust-btn"
                    @click="removeType(i)"
                    color="primary"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </div>
          </v-row>
          <div>
            <div
              v-if="
                que.questionType.id === QUE_TYPES.COMPREHENSION ||
                  que.questionType.id === QUE_TYPES.TC
              "
              class="check-cust"
            >
              <div class="ts-label-50">Select Subtype:</div>
              <div class="private-radio create-question-radio-group">
                <div
                  class="create-question-radio myt-test-creation"
                  v-for="sType in que.subTypes"
                  :key="sType.id"
                >
                  <input
                    type="radio"
                    :id="sType.id"
                    :name="sType.id"
                    v-model="que.selectedSubType"
                    :value="sType.id"
                    color="red"
                  />
                  <i
                    v-if="que.selectedSubType == sType.id"
                    aria-hidden="true"
                    class="v-icon notranslate mdi mdi-radiobox-marked theme--light red--text"
                  ></i>
                  <i
                    v-else
                    aria-hidden="true"
                    class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
                  ></i>
                  <label @click="questionsList[i].selectedSubType = sType.id">{{
                    sType.value
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="footer-btn-test">
      <div class="add-remove-sub">
        <div
          v-if="shouldShowAddQuestionType"
          @click="addNewQuestion"
          class="circle-icon"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span>Add Question Type</span>
        </div>
        <!-- <div class="circle-icon" @click="openDialog">
                    <div v-if="isInstructionsAdded">
                        <v-icon>mdi-pencil-circle</v-icon>

                        <span>Edit Instructions</span>
                    </div>
                    <div v-else>
                        <v-icon>mdi-plus-circle</v-icon>

                        <span>Add Instructions</span>
                    </div>
                </div> -->
      </div>
      <div class="next-btn-footer">
        <v-btn
          class="right-btn cust-btn min-100 myt-other-button"
          color="primary"
          @click="
            onBackClick({
              questionsList
            })
          "
          >Back</v-btn
        >
        <v-btn
          class="right-btn cust-btn min-100 leftspacing-15 myt-next"
          color="primary"
          @click="questionDetailsDialog()"
          >Next</v-btn
        >
        <!-- <v-btn class="right-btn cust-btn min-150" color="primary" @click="AddQuestionDialog()">Next</v-btn> -->
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="{
        stepOneData,
        stepTwoData,
        stepThreeData,
        stepFourData,
        persistent,
        patternData,
        questionTypes: questionTypes2
      }"
      :onCustomizeClick="onCustom"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "../../../../utils/constants";

export default {
  name: "PatternI",
  props: [
    "onBackClick",
    "data",
    "stepOneData",
    "onCustomizeClick",
    "stepTwoData",
    "stepThreeData",
    "stepFourData",
    "questionType",
    "questionTypes2",
    "clearData",
    "patternData"
  ],
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.matchHeight();
    this.questionTypes = this.questionType;
    if (this.data && this.data.questionsList) {
      this.questionsList = this.data.questionsList;
    } else {
      this.addNewQuestion();
    }
    this.getChaptersForAllSubjects();
  },
  data() {
    return {
      shouldScroll: false,
      heightblock: null,
      finalpattern: null,
      dialog: false,
      status: false,
      questionTypes: [],
      questionsList: [],
      questions: [],
      modalwidth: null,
      cComponent:
        "components/coordinator/Tests/CustomizedTests/AddInstructions",
      persistent: false,
      selectedQuestionType: 0,
      subjectChapterId: {},
      // questionTypes2:[],
      mandatoryType: [
        {
          label: "Allow only #mandatoryQuestions.",
          value: 0
        },
        {
          label: "Evaluate Best #mandatoryQuestions.",
          value: 1
        }
      ]
    };
  },
  computed: {
    shouldShowAddQuestionType() {
      return this.getQuestionTypes().length !== 0;
    }
  },
  updated() {
    if (this.shouldScroll) {
      this.scrollToEnd();
      this.shouldScroll = false;
    }
  },
  methods: {
    ...mapActions({
      getMYTRefData: "utilStore/getMYTRefData",
      getMYTSubTypeList: "utilStore/getMYTSubTypeList",
      setQuestions: "questionStore/setQuestions",
      setQuestionsTypeList: "questionStore/setQuestionsTypeList",
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic"
    }),
    onCustom(data) {
      let questiondata = {
        data,
        stepOneData: this.stepOneData,
        stepTwoData: this.stepTwoData,
        stepThreeData: this.stepThreeData,
        stepFourData: this.stepFourData,
        questionsList: this.questionsList,
        persistent: this.persistent,
        questionTypes: this.questionTypes
      };
      this.onCustomizeClick(questiondata);
    },
    showPartialMarking(que) {
      if (
        que.questionType.id === this.QUE_TYPES.MULTIPLE_CORRECT ||
        (que.questionType.id === this.QUE_TYPES.COMPREHENSION &&
          que.selectedSubType &&
          (que.selectedSubType == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
            que.selectedSubType == this.QUE_TYPES.COMPREHENSION_3Q_MA))
      ) {
        return true;
      }
      return false;
    },
    getChaptersForAllSubjects() {
      let subjectIds = this.stepTwoData.selectedSubjects.map((subject) =>
        this.getSubjectId(subject.value)
      );
      let reqData = {
        level: 3,
        parent_ids: subjectIds
      };
      this.$root.showLoader = true;

      this.getDataTreeWithLevelPublic(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.stepTwoData.selectedSubjects.map((subject) => {
            let sub = response.find(
              (s) =>
                s.parent == subject.value.id ||
                s.sub_subject === subject.value.code
            );
            this.subjectChapterId[subject.value.id] = {
              chapterId: sub.id
            };
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    questionDetailsDialog() {
      let questionNo = 1;
      let questionTypeList = [];
      if (this.validate()) {
        if (this.questionsList && this.questionsList.length) {
          if (this.stepTwoData && this.stepTwoData.selectedSubjects) {
            this.questions = [];
            let currentSubjectId =
              this.stepTwoData.selectedSubjects &&
              this.stepTwoData.selectedSubjects[0]
                ? this.stepTwoData.selectedSubjects[0].id
                : 0;
            let subIndex = 0;
            let chapterId = 0;
            this.stepTwoData.selectedSubjects.map((subject) => {
              chapterId = this.subjectChapterId[subject.value.id]
                ? this.subjectChapterId[subject.value.id].chapterId
                : 0;
              if (currentSubjectId != subject.value.id) {
                currentSubjectId = subject.value.id;
                ++subIndex;
              }
              this.questionsList.map((qType) => {
                let quesType = _.cloneDeep(qType);
                quesType.subject = subject;
                quesType.subIndex = subIndex;
                quesType.chapterId = chapterId;
                questionTypeList.push(quesType);
              });
            });
          }
        }
        this.setQuestionsTypeList(questionTypeList);
        // this.setQuestions(this.questions);

        this.persistent = true;
        this.cComponent =
          "views/pages/mytuser/components/customizedMYTTestsSubPopup";
        this.modalwidth = "850px";
        this.status = true;
      }
    },
    getSubTypes(que) {
      let postData = {
        parent_id: que.questionType.id
      };
      this.getMYTSubTypeList(postData)
        .then((response) => {
          let list = [];
          response.map((x) => {
            let canAdd = true;
            this.questionsList.map((xx) => {
              if (xx.selectedSubType == x.id) {
                canAdd = false;
              }
            });
            if (canAdd) {
              list.push(x);
            }
          });
          if (list.length == 1) {
            que.isRemovedComprehension = true;
          } else {
            que.isRemovedComprehension = false;
          }
          this.$set(que, "subTypes", list);
          this.$set(que, "selectedSubType", list[0].id);
        })
        .catch((err) => {});
    },
    checkQuestionType(que, i) {
      if (
        this.questionsList[i] &&
        this.questionsList[i].subTypes &&
        this.questionsList[i].selectedSubType
      ) {
        delete this.questionsList[i].subTypes;
        delete this.questionsList[i].selectedSubType;
      }
      if (
        que.questionType.id === this.QUE_TYPES.COMPREHENSION ||
        que.questionType.id === this.QUE_TYPES.TC
      ) {
        this.getSubTypes(que);
      }
    },
    getQuestionTypes(que) {
      let list = [],
        i = 0;
      this.questionTypes.map((x) => {
        let canAdd = true;
        this.questionsList.map((xx, j) => {
          if (
            que != xx &&
            xx.questionType.id == x.value.id &&
            x.value.id != 7
          ) {
            canAdd = false;
          }
          if (
            que != xx &&
            xx.questionType.id == x.value.id &&
            x.value.id == 7
          ) {
            i++;
          }
          if (i && i > 5 && x.value.id == 7) {
            canAdd = false;
          }
        });
        if (canAdd) {
          list.push(x);
        }
      });
      return list;
    },
    matchHeight() {
      this.heightblock = this.$refs.infoBox.clientHeight;
      this.finalpattern = this.heightblock - 60;
    },
    scrollToEnd() {
      var content = this.$refs.refQuestionType;
      content.scrollTop = content.scrollHeight;
    },
    addNewQuestion() {
      this.questionsList.push({
        questionType: {},
        numberOfQuestion: 0,
        noOfMandatoryQuestions: 0,
        correctMarkingSchema: 0,
        inCorrectMarkingSchema: 0,
        partialMarking: false
      });
      this.shouldScroll = true;
    },
    onClose(data) {
      this.status = data.status;
      if (data.reloadPreview) {
        this.clearData();
      }
      // if (!data.fromAlertBox && data && (data.instructions || data.instructions=="")) {
      //     this.instructions = data.instructions;
      // }
    },
    // openDialog() {
    //     this.cComponent =
    //         "components/coordinator/Tests/CustomizedTests/AddInstructions";
    //     this.modalwidth = "1000px";
    //     this.status = true;
    //     this.persistent = false;
    // },
    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"] };
      this.getMYTRefData(reqData)
        .then((response) => {
          this.loading = false;
          this.questionTypes2 = response.QUESTION_TYPE.map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
          this.questionTypes = response.QUESTION_TYPE.filter(
            (xx) =>
              xx.id != 14 &&
              xx.id != 15 &&
              xx.id != 16 &&
              xx.id != 17 &&
              xx.id != 18 &&
              xx.id != 20 &&
              xx.id != 21 &&
              xx.id != 23 &&
              xx.id != 24 &&
              xx.id != 8
          ).map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    AddQuestionDialog() {
      let questionNo = 1;
      if (this.validate()) {
        if (this.questionsList && this.questionsList.length) {
          if (this.stepTwoData && this.stepTwoData.selectedSubjects) {
            this.questions = [];
            let currentSubjectId =
              this.stepTwoData.selectedSubjects &&
              this.stepTwoData.selectedSubjects[0]
                ? this.stepTwoData.selectedSubjects[0].id
                : 0;
            let subIndex = 0;
            this.stepTwoData.selectedSubjects.map((x) => {
              if (currentSubjectId != x.id) {
                currentSubjectId = x.id;
                ++subIndex;
              }
              this.questionsList.map((xx) => {
                for (let k = 0; k < xx.numberOfQuestion; k++) {
                  this.questions.push({
                    index: questionNo,
                    subIndex,
                    subject: x,
                    question_text: "",
                    solution: "",
                    correct_answer: null,
                    options: [],
                    options_abc: [],
                    options_pqr: [],
                    hints: [],
                    questions: [],
                    startValue: null,
                    endValue: null,
                    questionType: xx.questionType,
                    subtype: null,
                    correctMarkingSchema: 1,
                    inCorrectMarkingSchema: 0,
                    partialMarking:
                      xx.questionType.id === this.QUE_TYPES.MULTIPLE_CORRECT ||
                      xx.questionType.id === this.QUE_TYPES.COMPREHENSION
                        ? xx.partialMarking
                        : false
                  });
                  questionNo++;
                }
              });
            });
          }
        }
        this.setQuestions(this.questions);
        this.persistent = true;
        this.cComponent = "components/coordinator/Questionadd";
        this.modalwidth = "1000px";
        this.status = true;
      }
    },
    validate() {
      let valid = true;
      let count = 0;
      // if (
      //     !this.instructions ||
      //     this.extractContent(this.instructions, true).trim() === ""
      // ) {
      //     this.$toasted.error(`Please enter instructions`, {
      //         icon: "info",
      //     });
      //     return false;
      // }
      for (let i = 0; i < this.questionsList.length; i++) {
        let xx = this.questionsList[i];
        count += parseInt(xx.numberOfQuestion);
        if (!xx.questionType || !xx.questionType.id) {
          this.$toasted.error(
            `Please select question type for question no.${i + 1} `,
            { icon: "info" }
          );
          valid = false;
          break;
        } else if (!xx.numberOfQuestion || xx.numberOfQuestion < 1) {
          this.$toasted.error(
            `Please enter number of question for question type no.${i + 1}`,
            { icon: "info" }
          );
          valid = false;
          break;
        }else if (
          !xx.noOfMandatoryQuestions ||
          parseInt(xx.numberOfQuestion) < parseInt(xx.noOfMandatoryQuestions) ||
          parseInt(xx.noOfMandatoryQuestions) == 0
        ) {
          this.$toasted.error(
            `Please enter valid number of mandatory questions for question no.${i +
              1}`,
            { icon: "info" }
          );
          valid = false;
          break;
        }
      }

      return valid;
    },
    isValidPattern(num) {
      let regex = /^0$|^-?[1-9]\d*(\.\d+)?$/;
      if (regex.test(num)) {
        return true;
      }
      return false;
    },
    removeType(idx) {
      this.questionsList.splice(idx, 1);
    }
  }
};
</script>
